import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { Iconify } from '@mgm/common/components';
import { BaseTooltip } from '@mgm/common/components/base';

type TTourIcon = {
  handleStartTour: () => void
};

const TourIcon: FC<TTourIcon> = ({ handleStartTour }) => {
  const { t } = useTranslation('common');
  return (
    <BaseTooltip tooltipText={t('clockHereToStartAGuided')}>
      <Box
        sx={{
          cursor: 'pointer',
        }}
        alignItems="center"
        display="flex"
        onClick={handleStartTour}
      >
        <Iconify icon="cuida:help-outline" width={24} sx={{ color: '#A855F7' }} />
      </Box>
    </BaseTooltip>
  );
};

export {
  TourIcon,
};
